'use client'

import * as React from 'react'

export default function OverlayTitle ({ title }) {
  return (
    <div className=''>
      <div className='video-title-div' style={{ display: 'block' }} id='video-title-outer'>
        <div className='video-title-div-inner mt-3 mx-8 overflow-hidden whitespace-nowrap text-ellipsis text-white' id='video-title-inner' style={{ wordWrap: 'normal' }}>
          <span className='text-ellipsis text-white text-base lg:text-2xl font-medium overflow-hidden' style={{ textShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 2px' }}>{title}</span>
        </div>
      </div>
    </div>
  )
}
